/* eslint-disable camelcase */

// 1
import { graphql } from "react-relay";
// @ts-ignore
import {EntityEmployeeLeave} from "mutations/types.d.ts";
import updateEmployeeDocImpl from "../Employee/updateEmployeeDocImpl";
import findByIdEmployeeLeave from "./findByIdEmployeeLeave";

// 2
const mutation = graphql`
  mutation updateEmployeeLeaveMutation($id: hr_employees_docs_leaves_pk_columns_input!, $_set: hr_employees_docs_leaves_set_input!) {
    update_hr_employees_docs_leaves_by_pk(pk_columns: $id, _set: $_set) {
        id
        created_at
        doc
        days_booked
        due_to
        date
        expiry_date
        expiry_updated
        removed
        employee_comments
        type
        notes
        reason
        employee{
            id
            fname
            lname
            phone
            email
            id_num
            passport_num
        }
        company {
            id
            name
        }
        client {
            id
            name
        }
        project {
            id
            name
        }
        site {
            id
            name
        }
    }
  }
`;

// 3
export default async (attrs: EntityEmployeeLeave) => updateEmployeeDocImpl({
    mutation,
    attrs,
    findByIdEmployeeFn: findByIdEmployeeLeave,
    name: 'Leave',
    plural: 'leaves',
});
